import { useCallback } from 'react'
import styles from './multiSelect.module.scss'
import { Checkbox } from '../Checkbox/Checkbox'
import { useGetTranslation } from 'components/Translations/translationUtils'

type Props = {
	item: any
	getItemText(item: any): string | undefined
	onClick(item: any): void
	isSelected?: boolean
	disabled?: boolean
}

export const Option = ({ item, getItemText, onClick, isSelected, disabled }: Props) => {
	const getTranslation = useGetTranslation();

	const onClickCallback = useCallback(
		() => {
			!disabled && onClick(item);
		},
		[disabled, item, onClick]
	)

	return (
		<div
			className={styles.option}
			onMouseDown={onClickCallback}
		>
			<Checkbox
				value={isSelected}
				disabled={disabled}
			/>
			<span className={styles.option_text}>{getTranslation(getItemText(item))}</span>
		</div>
	)
}
